/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_CreateInputs */

const en_share_create = /** @type {(inputs: Share_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create link`)
};

const de_share_create = /** @type {(inputs: Share_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link erstellen`)
};

/**
* | output |
* | --- |
* | "Create link" |
*
* @param {Share_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const share_create = /** @type {((inputs?: Share_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_share_create(inputs)
	return en_share_create(inputs)
});